var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { withLazyFeatureGateErrorBoundary } from '@office-start/office-home-app-shared';
import { observeScanDialog } from '@office-start/scan-dialog-service';
import { IMMEDIATE_PRIORITY } from '@office-start/scheduler-service';
import React, { lazy, useEffect, useState } from 'react';
export var ScanDialog = function () {
    var _a = __read(useState(false), 2), showDialog = _a[0], setShowDialog = _a[1];
    useEffect(function () {
        var subscription = observeScanDialog().subscribe(setShowDialog);
        return function () {
            subscription.unsubscribe();
        };
    }, []);
    if (!showDialog) {
        return null;
    }
    var ScanDialogLazy = withLazyFeatureGateErrorBoundary(lazy(function () {
        return import(
        /* webpackChunkName: "scan-component" */ '@office-start/scan-component');
    }), 'ScanDialog', {
        disabledFeatureGateSelector: function (featureGates) { var _a; return !((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.captureScanGates) === null || _a === void 0 ? void 0 : _a.captureScanEnabled); },
        schedulePriority: IMMEDIATE_PRIORITY,
    });
    return React.createElement(ScanDialogLazy, { showDialog: showDialog });
};
//# sourceMappingURL=ScanDialog.js.map